import { ServerFileProvider } from "./serverProvider";

export class AnalysisProvider extends ServerFileProvider{
    constructor (){
        super('', 'Analysis');
    }

    get providerName(){
        return 'analysis'
    }
}